import { useState, type ReactNode } from "react";
import { useMediaSrc } from "./media.tsx";
import { radius as radiusVar, type RadiusToken } from "./tokens.ts";

export type ImageProps = {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  radius?: RadiusToken;
  fit?: "cover" | "contain";
  /** Shown instead when the image fails to load (e.g. a site's favicon that doesn't exist). */
  fallback?: ReactNode;
};

export function Image({ src, alt, width, height, radius, fit = "cover", fallback }: ImageProps) {
  // Message files and pending uploads resolve through the platform's media pipeline (auth token, local previews).
  const url = useMediaSrc(src);
  const [failed, setFailed] = useState<string | undefined>(undefined);
  if (fallback !== undefined && failed !== undefined && failed === url) return <>{fallback}</>;
  if (url === undefined) {
    return <span className="b-image-placeholder" role="img" aria-label={alt} style={{ width, height, borderRadius: radius === undefined ? undefined : radiusVar(radius) }} />;
  }
  return (
    <img
      className="b-image"
      src={url}
      alt={alt}
      width={width}
      height={height}
      loading="lazy"
      decoding="async"
      onError={fallback === undefined ? undefined : () => setFailed(url)}
      style={{ objectFit: fit, borderRadius: radius === undefined ? undefined : radiusVar(radius) }}
    />
  );
}
